import { getSpacing } from 'app/functions/grid';

/**
 * Get the CSS value of the spacing.
 */
export const getSpacingCSSValue = (value = getSpacing()) => value.map(v => `${v}px`);
